import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import img from "../assets/img/logo22.png";
import uc from "../assets/img/image_ucom.png";
import { menu } from "../translate";
import LockIcon from "@mui/icons-material/Lock";
import _ from 'lodash'
import Account from "../helpers/Account";
import Api from "../Api";
import Utils from "../Utils";
import Cookies from "js-cookie";
import { profileRequest, profileUrsRequest } from "../store/actions/users";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
const { REACT_APP_SERVER } = process.env;
import ats from '../assets/img/logo_light.png'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDownWideShort, faArrowUpShortWide, } from "@fortawesome/free-solid-svg-icons";
import { REACT_APP_API_URL } from '../config';


function UrsBlocked(props) {
    const [money, setMoney] = useState(0)
    const [type, setType] = useState(false)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const profile = useSelector(state => state.users.ursData)
    const [sortOrder, setSortOrder] = useState("desc");
    const [groups, setGroups] = useState({})
    const [type_did, setTypeDid] = useState('did')
    const [provider, setProvider] = useState('')
    useEffect(() => {
        (async () => {
            try {
                let { data } = await Api.ursBlocked()
                let m = 0
                const grouped = {};
                const latestByMember = {};
                data.rows.forEach(record => {
                    const existing = latestByMember[record.id];
                    if (!existing || new Date(record.disable_date) > new Date(existing.disable_date)) {
                        latestByMember[record.id] = record;
                    }
                });
                const latestRecords = Object.values(latestByMember);

                latestRecords.sort((a, b) => {
                    const d1 = new Date(a.disable_date);
                    const d2 = new Date(b.disable_date);
                    return sortOrder === "desc" ? d2 - d1 : d1 - d2;
                });

                data.rows = Object.values(latestRecords);

                data.rows.map(s => m += +s.sgumar)

                setMoney(m)

                data.rows.forEach(record => {
                    const date = new Date(record.disable_date);
                    const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`; // e.g. "2025-07"

                    if (!grouped[monthKey]) {
                        grouped[monthKey] = [];
                    }

                    grouped[monthKey].push(record);
                });
                setGroups(grouped)

            } catch (e) {
                console.log(e);

            }
        })()
    }, [sortOrder])
    const handleDownload = async () => {
        const url = `${REACT_APP_API_URL}/rest/report_block_exel?id=${provider}&type=${type_did}`;

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'report.csv'); // optional: sets a default filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    const handleChangeProvider = (ev) =>{
        setProvider(ev)
        if(+ev === 11 || +ev === 60 || ev === "qar"){
            setTypeDid('provider')
        }
    }

    useEffect(() => {
        if (!Account.getUrsToken()) {
            navigate('/admin_login')
        }
    }, [])
    const handleId = useCallback(async (id) => {
        try {
            Cookies.set('viewer', id, { expires: 30 })
            Cookies.set('original', profile.id, { expires: 30 })
            Cookies.set('key', profile.uid, { expires: 30 })
            const { data } = await Api.loginAsUser(id, profile.id, profile.uid)
            localStorage.setItem('access_token', data.access_token)
            localStorage.setItem('refresh_token', data.refresh_token)
            await dispatch(profileRequest())
            navigate('/')
        } catch (e) {

        }
    }, [profile])
    useEffect(() => {
        (async () => {
            await dispatch(profileUrsRequest())
        })()
    }, [])
    const tableRef = useRef(null);


    return (
        <>
            <Helmet>
                <title>Urs</title>
            </Helmet>
            <header className="header">
                <div className="header_container container" style={window.innerWidth > 1030 ? {} : { maxWidth: '100%' }}>
                    <div className="header_block">
                        <div className="left">
                            {REACT_APP_SERVER === 'Beeline' ? <Link to="/urs">
                                <figure>
                                    <img style={{ width: 100 }} src={img} alt='' />
                                </figure>
                            </Link> : REACT_APP_SERVER === 'ATS' ? <Link to="/">
                                <figure>
                                    <img style={{ width: 100 }} src={ats} alt='' />
                                </figure>
                            </Link> : <Link to="/">
                                <figure>
                                    <img src={uc} alt='' />
                                </figure>
                            </Link>}

                        </div>
                        <div className="right">
                            <div className="logout">
                                <Link to="/urs_online"> {menu.online[0]}</Link>
                            </div>
                            <div className="logout">
                                <Link to="/admin_login"><LockIcon
                                    sx={{ color: '#CD405F', fontSize: 20 }} /> {menu.logout[0]}</Link>
                            </div>

                        </div>

                    </div>
                </div>
            </header>
            <div className="urs_table" style={{ display: 'flex', justifyContent: 'center' }}>

                <div className=" tableParent  file" style={window.innerWidth <= 1024 ? { overflow: 'scroll', background: 'white', padding: 35, width: '95vw', overflowY: 'hidden', } : { overflowY: 'hidden', background: 'white', padding: 35, width: '75vw' }}>
                    <div onClick={() => setType(true)} className='d-flex align-items-center justify-content-end' style={{ margin: '20px 0' }}>
                        <span className='addBtn'>Ընտրել DID-ի տեսակը</span>
                    </div>
                    <table ref={tableRef} cellPadding="0" cellSpacing="0">
                        <thead>
                            <tr>
                                <td>NN</td>
                                <td><b>Fio</b></td>
                                <td><b>Name</b></td>
                                <td><b>Registered Date</b></td>
                                <td><b>Blocked date</b>
                                    <span onClick={() => setSortOrder(prev => (prev === "desc" ? "asc" : "desc"))}>{sortOrder === 'asc' ?
                                        <FontAwesomeIcon icon={faArrowUpShortWide} /> :
                                        <FontAwesomeIcon icon={faArrowDownWideShort} />}</span></td>
                                <td><b>Gumar</b></td>
                            </tr>
                        </thead>

                        {/* {newData.map(d => (
                            <tr key={d.id}>
                                <td>{d.id}</td>
                                <td>{d.fio}</td>
                                <td>{d.name}</td>
                                <td>{new Date(d?.registered).toLocaleString()}</td>
                                <td>{new Date(d.disable_date).toLocaleString()}</td>
                                <td>{parseInt(d.sgumar)}</td>
                            </tr>
                        ))} */}

                        {Object.keys(groups).map(l => {
                            let mon = 0
                            return (
                                <tbody>
                                    {groups[l].map(d => {
                                        mon += parseInt(d.sgumar)
                                        return (
                                            <tr style={{ cursor: "pointer" }} onClick={() => handleId(d.id)} key={d.id}>
                                                <td>{d.id}</td>
                                                <td>{d.fio}</td>
                                                <td>{d.name}</td>
                                                <td>{new Date(d?.registered).toLocaleString()}</td>
                                                <td>{new Date(d.disable_date).toLocaleString()}</td>
                                                <td>{parseInt(d.sgumar)}</td>
                                            </tr>
                                        )
                                    })}
                                    <tr style={{ background: "#ebebeb" }} key={l}><td colSpan={3}>Ժամանակացույց - {l}</td><td colSpan={2}>Գումար - {mon}</td><td>Քանակ - {groups[l].length}</td></tr>

                                </tbody>
                            )
                        })}
                        <tfoot>
                            <tr><td colSpan={6} style={{ textAlign: "right" }}><b>{money}</b></td></tr>

                        </tfoot>
                    </table>
                </div>
                {type && (
                <div className="modal-backdrop-my" onClick={() => setType(false)}>
                    <div className="modal-content-my" onClick={(e) => e.stopPropagation()}>
                        <select value={provider} onChange={(ev) => {handleChangeProvider(ev.target.value)}} style={{ padding: 10, width: "100%", marginBottom: 20 }}>
                            <option value="">Select</option>
                            <option value="1">Ucom</option>
                            <option value="2">Ucom Peer</option>
                            <option value="4">Telegram</option>
                            <option value="11">011 Fix numbers</option>
                            <option value="60">060 Fix numbers</option>
                            <option value="qar">4 Digit numbers</option>
                        </select>
                        <button className="addBtn" onClick={handleDownload}>Download</button>
                    </div>
                </div>
            )}
            </div>


        </>

    );
}

export default UrsBlocked;
